module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/wizard_tablet-533ecb8a1d05f5f39103492d3e413187.png";